export default function () {
    const lokalizacja_container = $('#lokalizacja');

    lokalizacja_container.on('click', '.lokalizacja-btns .btn', (e) => {
        let btn = $(e.currentTarget);
        let target = $(btn.data('target'));
        if (target.length && !target.hasClass('active')) {
            lokalizacja_container.find('.lokalizacja-tab.active').removeClass('active');
            target.addClass('active');
            lokalizacja_container.find('.lokalizacja-btns .btn.active').removeClass('active');
            btn.addClass('active');
        }
    });
}
